import React from 'react';
import { renderToString } from 'react-dom/server';

import { ImageIcon } from '../../../icon/regular';
import {
  InstructionCSSClasses,
  InstructionEvent,
  InstructionActionTooltip,
} from '../types';
import { addInstructionEvent, emitInstructionEvent } from '../utils';
import BlockInstruction from '../base-instruction/BlockInstruction';

class ImageInstructionBlock extends BlockInstruction {
  static initiable = false;

  get isInit() {
    return ImageInstructionBlock.initiable;
  }

  set isInit(value: boolean) {
    ImageInstructionBlock.initiable = value;
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.IMAGE_INSTRUCTION_BLOCK,
      action: InstructionCSSClasses.IMAGE_INSTRUCTION_BLOCK_ACTION,
      content: InstructionCSSClasses.IMAGE_INSTRUCTION_BLOCK_CONTENT,
    };
  }

  static get toolbox() {
    return {
      icon: renderToString(<ImageIcon style={{ height: 20 }} />),
      title: 'Image',
    };
  }

  get tooltip() {
    return InstructionActionTooltip.image;
  }

  openModal(instructionId: string) {
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_IMAGE_INSTRUCTION_MODAL,
      {
        instructionId,
        isInline: false,
      },
    );
  }

  initEvents(): void {
    this.saveInstruction = this.saveInstruction.bind(this);
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_IMAGE_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }

  removeEvents(): void {
    this.api.events.off(
      InstructionEvent.SAVE_IMAGE_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }
}

export default ImageInstructionBlock;
